import { render, staticRenderFns } from "./organization-member-form.vue?vue&type=template&id=59a9eff3"
import script from "./organization-member-form.vue?vue&type=script&lang=js"
export * from "./organization-member-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports